import * as _ from 'lodash';
import { action, observable, runInAction } from 'mobx';
import { DefaultKpiType, IKpiType } from 'src/Definitions';
import { Client, IKpiTypeDto, SwaggerResponse } from 'src/generated_client';

export default class KpiTypesStore {
    @observable
    public isLoading: boolean = false;
    @observable
    public isModalOpen: boolean;
    @observable
    public kpiTypes: IKpiType[];
    @observable
    public selectedKpiType?: IKpiTypeDto;

    constructor(private client: Client) {}

    @action.bound
    public getAllKpiTypes(pageNumber?: number): Promise<void> {
        if (!pageNumber) {
            this.kpiTypes = [];
            pageNumber = 1;
        }
        let totalPages = 0;
        this.isLoading = true;
        return this.client
            .getAllKpiTypes(undefined, pageNumber, undefined, undefined, undefined)
            .then((resp: SwaggerResponse<IKpiTypeDto[]>) => {
                runInAction(() => {
                    this.kpiTypes = this.kpiTypes.concat(this.setupKpiTypes(resp.result));
                    totalPages = JSON.parse(resp.headers['x-pagination']).TotalPages;
                });
            })
            .catch(() => {})
            .finally(() => {
                runInAction(() => {
                    this.isLoading = false;
                });
                if (totalPages - pageNumber! !== 0) {
                    return this.getAllKpiTypes(++pageNumber!);
                }
                return;
            });
    }

    private setupKpiTypes = (kpiTypes: IKpiTypeDto[]) => {
        return kpiTypes.map((x) => this.addDefaultFields(x));
    };

    private addDefaultFields = (kpiType: IKpiTypeDto): IKpiType => {
        return { ...DefaultKpiType(), ...kpiType };
    };
}



// WEBPACK FOOTER //
// ./src/stores/KpisStore/KpiTypesStore.ts